var isDemi = process.env.VUE_APP_IS_DEMI;
export default {
  name: 'Detail',
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    replaceContent: function replaceContent() {
      if (!this.detail.content) return '';
      return this.detail.content.replace(/\[平台名称\]/g, isDemi === 'true' ? '德米' : '青云端');
    }
  },
  methods: {
    cancel: function cancel() {
      localStorage.setItem('readNotice', true);
      this.$emit('change', false);
    }
  }
};